import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import OneColumnC from '../components/OneColumnC/OneColumnC'
import FAQS from '../components/FAQS/FAQS'
// import RefSignUp from '../components/RefSignUp/RefSignUp'

const Refereeing = () => {
  const refFaq = [
    {
      id: 1,
      question: 'What are the age requirements to referee for OSUSC recreation?',
      answer: 'Players who are in 5th grade may start refereeing for OSUSC recreational program'
    },
    {
      id: 2,
      question: 'What are the requirements to become a recreational soccer referee?',
      answer: 'We have 1 clinic in the fall and 1 clinic in the spring. Players who are interested in refereeing must attend the clinic in order to be eligible to referee recreation games.'
    },
    {
      id: 3,
      question: 'What are the commitment requirements to referee recreation games?',
      answer: 'We ask returning and new referees to give the recreation referee coordinator their commitment priorites before the 6 week recreation program begins.'
    },
    {
      id: 4,
      question: 'How are referees informed about the weekend schedule? ',
      answer: 'The head of referees will communicate a week in advance.'
    },
    {
      id: 5,
      question: 'Yes! Referees are paid, when does that happen?',
      answer: 'A check will be mail to the referee after the season ends'
    },


  ]

  return (
    <div>
      <Navbar />
      <div className="app__background section__padding">
        <div className="app__content">
          <h1 className="headtext__roboto" style={{ paddingBottom: '3rem' }}>Recreational Refereeing</h1>
        </div>
        <div>
          <OneColumnC
            subtitleC="Referee Program"
            paragraphC="Learning the game of soccer is not only playing on a team or with friends it's also understanding the rule/laws of the game. 
          We encourage all competivtive team players to consider and expand their knowledge of soccer to particpate in our referee progam. 
          The information below provides details on what to expect as well as what is required by OSUSC."          />
        </div>
       {/* <RefSignUp /> */}
        <div className="app__faq" >
          <FAQS faqTitle="FAQ's" faqs={refFaq} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Refereeing